import React from "react";

export const PreviewContext = React.createContext(false);
